
import React, { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Plus, X } from 'lucide-react';

interface ConfirmationSectionProps {
  confirmations: Array<{id: string, value: string}> | undefined;
  onChange: (field: string, value: any) => void;
}

const ConfirmationSection: React.FC<ConfirmationSectionProps> = ({ 
  confirmations, 
  onChange 
}) => {
  const [newConfirmation, setNewConfirmation] = useState('');
  
  const addConfirmation = () => {
    if (!newConfirmation.trim()) return;
    
    const updatedConfirmations = [...(confirmations || []), {
      id: crypto.randomUUID(),
      value: newConfirmation
    }];
    
    onChange('confirmations', updatedConfirmations);
    setNewConfirmation('');
  };

  const removeConfirmation = (id: string) => {
    const updatedConfirmations = confirmations?.filter(c => c.id !== id) || [];
    onChange('confirmations', updatedConfirmations);
  };

  return (
    <div className="space-y-2">
      <Label>Confirmation/Booking Numbers</Label>
      <div className="flex flex-wrap gap-2 mb-2">
        {confirmations?.map(confirmation => (
          <Badge key={confirmation.id} variant="secondary" className="flex items-center gap-1">
            {confirmation.value}
            <Button
              variant="ghost"
              size="icon"
              onClick={() => removeConfirmation(confirmation.id)}
              className="h-4 w-4 p-0 hover:bg-transparent"
            >
              <X className="h-3 w-3" />
            </Button>
          </Badge>
        ))}
      </div>
      <div className="flex items-center gap-2">
        <Input 
          value={newConfirmation}
          onChange={(e) => setNewConfirmation(e.target.value)}
          placeholder="e.g., AB123XYZ"
          className="flex-1"
        />
        <Button 
          type="button" 
          variant="outline"
          size="icon"
          onClick={addConfirmation}
        >
          <Plus className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default ConfirmationSection;
